import '.bb{position:relative;}.ssr-plugin'
import '.a1{width:100%;}.ssr-plugin'
import '.gb{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.bp{align-items:flex-start;}.ssr-plugin'
import '.n{padding:2rem;}.ssr-plugin'
import '.cg{background:var(--shades-white);}.ssr-plugin'
import '.aa{overflow:hidden;}.ssr-plugin'
import '.ar{position:absolute;}.ssr-plugin'
import '.ik{top:50%;}.ssr-plugin'
import '.il{right:1rem;}.ssr-plugin'
import '.im{transform:translateY(-50%);}.ssr-plugin'
import '.in{width:120px;}.ssr-plugin'
import '.io{height:120px;}.ssr-plugin'
import '.ip{z-index:0;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.hy{z-index:1;}.ssr-plugin'
import '.af{gap:0.5rem;}.ssr-plugin'
import '.iq{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="bb a1 gb a e b bp n cg aa"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="ar ik il im in io ip a f b"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="bb hy a e bp af iq"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
